import {
  GET_COUPONS,
  COUPONS_LIST,
  ADD_COUPON,
  UPDATE_COUPON,
  DELETE_COUPON,
  UPDATE_COUPON_STATUS,
  GET_COUPON_DETAILS,
  APPLIED_COUPON_HISTORY,
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const couponSlice = createCrudSlice({
  name: "coupons",
  urls: {
    getList: GET_COUPONS,
    getDropdownList: COUPONS_LIST,
    add: ADD_COUPON,
    update: UPDATE_COUPON,
    delete: DELETE_COUPON,
    updateStatus: UPDATE_COUPON_STATUS,
    getDetails: GET_COUPON_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {
    getAppliedCouponHistory: {
      type: "coupons/getAppliedCouponHistory",
      url: () => `${APPLIED_COUPON_HISTORY}`,
      method: "post",
      stateKey: "appliedCouponHistory",
      loadingKey: "loading",
    },
  },
  initialState: {
    visibility: "",
    appliedCouponHistory :[],
    coupon_id :"",
    user_id :""
  },
});

// Export actions
export const { setFilter, resetFilters } = couponSlice.actions;

// Export thunks
export const {
  getList: getCouponsList,
  getDropdownList: getCouponsDropdownList,
  add: addCoupon,
  update: updateCoupon,
  delete: deleteCoupon,
  updateStatus: updateCouponStatus,
  getDetails: getCouponDetails,
  getAppliedCouponHistory
} = couponSlice.thunks;

// Export reducer
export default couponSlice.reducer;
